import { MemberCommitmentHistory as MemberCommitmentHistoryComponent } from '../../../components/Commitment/Categories/MemberCommitmentHistory';

export function MemberCommitmentHistory() {
  return <MemberCommitmentHistoryComponent />;
}
